exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subnav {\n  display: flex;\n  margin: 1em 0; }\n  .subnav a {\n    padding: 5px 12px;\n    font-weight: 600;\n    border-radius: 14px;\n    background: #dae2ec; }\n    .subnav a.active {\n      background: #041847;\n      color: #dae2ec; }\n    .subnav a + a {\n      margin-left: 1em; }\n", ""]);

// exports
